import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy, CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { UniversalInterceptor } from './interceptors/universal.interceptor';
import { AdminModule } from './admin';
import { HomeModule } from './home';
import { CatalogsFormationsModule } from './catalogs-formations';
import { DownloadModule } from './download/download.module';
import { CursusModule } from './cursus';
import { InscriptionsModule } from './inscriptions/inscriptions.module';
import { StagesModule } from './stages';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SharedPipeModule } from './pipes/shared-pipe-module';

import { ToastModule } from './toast/toast.module';
import { AlertComponent } from './alert/alert.component';
import { AlertService, StoreService } from './core';
import { CoreService, ErrorModule } from 'projects/lib-components/src/public_api';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from './error/error.component';


@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    ErrorComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    FormsModule,
    NgbCollapseModule,
    AdminModule,
    HomeModule,
    CatalogsFormationsModule,
    DownloadModule,
    CursusModule,
    StagesModule,
    InscriptionsModule,
    SharedPipeModule,
    ToastModule,
    ErrorModule,
    RouterModule,
    CommonModule,
    AppRoutingModule
  ],
  exports: [
    ErrorModule
  ],
  providers: [
    StoreService,
    AlertService,
    CoreService,
    { provide: HTTP_INTERCEPTORS, useClass: UniversalInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AuthGuard
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
